import update from 'immutability-helper';
import { AuthReduxActions } from './Action';
import { AuthenticationActions } from 'react-aad-msal';

export const authState: AuthState = {
    isExpiritySession: false,
    ExpritySessionMsg: '',
    isRegularLogout: false,
    isRegularLoggingIn: false,
    isIdleCheckLogout: false,
    isOrgSelected: false,
    isUserLoggedIn: false,
    logo: '',
    accessToken: '',
    refreshToken: '',
    role: '',
    isAAD: false,
    email: null,
    refreshTokenIn: 0,
};

const AuthStateReducer = (
    state = authState,
    action: any = { type: '', payload: {} }
): AuthState => {
    switch (action.type) {
        case AuthReduxActions.AUTH_SET_LOGIN_STATUS:
            return update(state, {
                $merge: {
                    isExpiritySession: false,
                    isRegularLoggingIn: true,
                    ExpritySessionMsg: '',
                    ...action.payload,
                },
            });
        case AuthReduxActions.RESET_LOGGING_IN:
            return update(state, {
                $merge: {
                    isRegularLoggingIn: false,
                },
            });
        case AuthReduxActions.RESET_LOGOUT_FIELD:
            return update(state, {
                $merge: {
                    isRegularLogout: false,
                },
            });
        case AuthenticationActions.LogoutSuccess:
        case AuthReduxActions.LOGOUT:
            return update(state, {
                $merge: {
                    ...authState,
                    isRegularLogout: true,
                },
            });
        case AuthReduxActions.SESION_EXPIRED_LOGOUT:
            return update(state, {
                $merge: {
                    ...action.payload,
                },
            });
        case AuthReduxActions.AUTH_SET_UPDATE_STATUS:
            return update(state, {
                $merge: {
                    ...action.payload,
                },
            });
        case AuthReduxActions.IDLECHECK_EXPIRED_LOGOUT:
            return update(state, {
                $merge: {
                    isIdleCheckLogout: action.payload,
                },
            });
        case AuthReduxActions.REFRESH_TOKEN:
            return update(state, {
                $merge: {
                    refreshTokenIn: action.payload,
                },
            });
        default:
            return state;
    }
};

export default AuthStateReducer;
